import { render, staticRenderFns } from "./IntegralShop.vue?vue&type=template&id=d8941206&scoped=true"
import script from "./IntegralShop.vue?vue&type=script&lang=js"
export * from "./IntegralShop.vue?vue&type=script&lang=js"
import style0 from "./IntegralShop.vue?vue&type=style&index=0&id=d8941206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8941206",
  null
  
)

export default component.exports